import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListfilesComponent } from './pages/listfiles/listfiles.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  {path:"", component: LoginComponent},
  {path:"listnfs", component: ListfilesComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
